/* =========================================================================
   HIRA MODA – Warenkorb H&M/OTTO-Funktionen
   1) Groesse direkt im Warenkorb aendern (Varianten-Wechsel)
   2) Merken (Merkzettel ueber localStorage, ohne App) MIT sichtbarem Zaehler
      oben im Warenkorb-Kopf (OTTO-Stil) + Sofort-Bestaetigung (Toast).
   Rein additiv: fuegt Bedienelemente per JS in den bestehenden Drawer ein,
   veraendert KEINE bestehende Warenkorb-Logik. Mehrsprachig de/en/ar.
   ========================================================================= */
(function () {
  if (window.__hmCartHM) return;
  window.__hmCartHM = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  var LANG = (document.documentElement.getAttribute('lang') || 'de').slice(0, 2).toLowerCase();
  var SAVE_KEY = 'hm_saved_items';

  var T = {
    de: { size: 'Größe', save: 'Merken', saved: 'Gemerkt', merklist: 'Merkzettel', soldout: 'ausverkauft',
          addToCart: 'In den Warenkorb', remove: 'Entfernen', emptySaved: 'Noch nichts gemerkt.',
          shopmore: 'Weiter shoppen', toastSaved: 'Zum Merkzettel hinzugefügt' },
    en: { size: 'Size', save: 'Save', saved: 'Saved', merklist: 'Saved', soldout: 'sold out',
          addToCart: 'Add to cart', remove: 'Remove', emptySaved: 'Nothing saved yet.',
          shopmore: 'Continue shopping', toastSaved: 'Added to your saved list' },
    ar: { size: 'المقاس', save: 'حفظ', saved: 'المحفوظة', merklist: 'المحفوظة', soldout: 'نفد',
          addToCart: 'أضف إلى السلة', remove: 'إزالة', emptySaved: 'لا شيء محفوظ بعد.',
          shopmore: 'متابعة التسوق', toastSaved: 'تمت الإضافة إلى المحفوظة' }
  };
  var L = T[LANG] || T.de;

  var HEART_OUTLINE =
    '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M12 20.5l-1.45-1.32C5.4 14.5 2 11.4 2 7.6 2 5 4 3 6.6 3c1.5 0 2.9.7 3.8 1.8L12 6.3l1.6-1.5C14.5 3.7 15.9 3 17.4 3 20 3 22 5 22 7.6c0 3.8-3.4 6.9-8.55 11.58L12 20.5z" ' +
    'stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';
  var HEART_FILLED =
    '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M12 20.5l-1.45-1.32C5.4 14.5 2 11.4 2 7.6 2 5 4 3 6.6 3c1.5 0 2.9.7 3.8 1.8L12 6.3l1.6-1.5C14.5 3.7 15.9 3 17.4 3 20 3 22 5 22 7.6c0 3.8-3.4 6.9-8.55 11.58L12 20.5z" ' +
    'fill="currentColor"/></svg>';

  var productCache = {};
  var observing = null;

  /* ---------- kleine Helfer ---------- */
  function getJSON(url, opts) { return fetch(url, opts).then(function (r) { return r.json(); }); }
  function postJSON(url, data) {
    return getJSON(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    });
  }
  function money(cents) {
    try { return (cents / 100).toLocaleString(LANG === 'de' ? 'de-DE' : 'en-US',
      { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }); }
    catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  }
  function readSaved() {
    try { var a = JSON.parse(localStorage.getItem(SAVE_KEY) || '[]'); return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  }
  function writeSaved(arr) { try { localStorage.setItem(SAVE_KEY, JSON.stringify(arr)); } catch (e) {} }
  function savedCount() { return readSaved().length; }
  function escapeHtml(s) {
    return (s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Toast (kurze Bestaetigung, ueberlebt Drawer-Neuaufbau) ---------- */
  function toast(msg) {
    try {
      var t = document.createElement('div');
      t.className = 'hm-toast';
      t.innerHTML = '<span class="hm-toast__i">' + HEART_FILLED + '</span><span>' + escapeHtml(msg) + '</span>';
      document.body.appendChild(t);
      requestAnimationFrame(function () { t.classList.add('is-in'); });
      setTimeout(function () {
        t.classList.remove('is-in');
        setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 320);
      }, 1700);
    } catch (e) {}
  }

  /* ---------- Merkzettel-Anzeige (Zaehler) im Kopf ---------- */
  function ensureHeaderMerk() {
    var header = document.querySelector('#CartDrawer .drawer__header');
    if (!header) return;
    if (header.querySelector('.hm-merk-ind')) { updateMerkBadge(false); return; }

    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'hm-merk-ind';
    b.setAttribute('aria-label', L.merklist);
    b.innerHTML = HEART_OUTLINE + '<span class="hm-merk-ind__badge" aria-hidden="true">0</span>';
    b.addEventListener('click', function () {
      var wrap = document.querySelector('#CartDrawer [data-hm-saved]');
      if (wrap) {
        wrap.open = true;
        try { wrap.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { wrap.scrollIntoView(); }
      } else {
        toast(L.emptySaved);
      }
    });

    var close = header.querySelector('.drawer__close') ||
                header.querySelector('button[class*="close"], .icon-close');
    if (close && close.parentNode === header) header.insertBefore(b, close);
    else header.appendChild(b);

    updateMerkBadge(false);
  }

  function updateMerkBadge(pop) {
    var ind = document.querySelector('#CartDrawer .hm-merk-ind');
    if (!ind) return;
    var n = savedCount();
    var badge = ind.querySelector('.hm-merk-ind__badge');
    if (badge) { badge.textContent = n; badge.style.display = n > 0 ? '' : 'none'; }
    ind.classList.toggle('has-items', n > 0);
    if (pop) {
      ind.classList.remove('is-pop');
      void ind.offsetWidth;            /* Reflow erzwingen, damit Animation neu startet */
      ind.classList.add('is-pop');
      setTimeout(function () { ind.classList.remove('is-pop'); }, 500);
    }
  }

  /* ---------- Drawer nach Aenderung neu laden ---------- */
  function applySections(sections) {
    if (sections && sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = doc.querySelector('#CartDrawer');
      var cur = document.querySelector('#CartDrawer');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    }
    if (sections && sections['cart-icon-bubble']) {
      var bub = document.querySelector('#cart-icon-bubble');
      var d2 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var fb = d2.querySelector('.shopify-section') || d2.body;
      if (bub && fb) bub.innerHTML = fb.innerHTML;
    }
    var cd = document.querySelector('cart-drawer');
    if (cd) {
      if (document.querySelector('#CartDrawer .cart-item')) cd.classList.remove('is-empty');
      else cd.classList.add('is-empty');
    }
    setTimeout(enhance, 0);
  }

  function changeLine(line, qty) {
    return postJSON(ROOT + 'cart/change.js', {
      line: line, quantity: qty,
      sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname
    });
  }
  function addVariant(id, qty) {
    return postJSON(ROOT + 'cart/add.js', {
      items: [{ id: parseInt(id, 10), quantity: qty || 1 }],
      sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname
    });
  }

  /* ---------- Groesse wechseln ---------- */
  function swapSize(line, newId, qty) {
    addVariant(newId, qty)
      .then(function () { return changeLine(line, 0); })
      .then(function (res) { applySections(res && res.sections); })
      .catch(function () {});
  }
  function getProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return getJSON(ROOT + 'products/' + handle + '.js')
      .then(function (p) { productCache[handle] = p; return p; })
      .catch(function () { return null; });
  }
  function sizeOptionIndex(product) {
    if (!product || !product.options) return -1;
    for (var i = 0; i < product.options.length; i++) {
      var name = (product.options[i].name || product.options[i] || '').toString().toLowerCase();
      if (name.indexOf('größe') > -1 || name.indexOf('grösse') > -1 ||
          name.indexOf('grosse') > -1 || name.indexOf('groesse') > -1 ||
          name.indexOf('size') > -1 || name.indexOf('مقاس') > -1) return i;
    }
    return -1;
  }
  function buildSizeSelect(line, product) {
    if (!product || !product.variants || product.variants.length < 2) return null;
    var sIdx = sizeOptionIndex(product);
    if (sIdx < 0) return null;

    var current = null, v, i;
    for (i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === line.variant_id || product.variants[i].id === line.id) { current = product.variants[i]; break; }
    }
    if (!current) return null;

    var sel = document.createElement('select');
    sel.className = 'hm-size-select';
    sel.setAttribute('data-hm-size', '');
    sel.setAttribute('aria-label', L.size);

    var added = 0;
    for (i = 0; i < product.variants.length; i++) {
      v = product.variants[i];
      var sameRest = true;
      for (var j = 0; j < current.options.length; j++) {
        if (j === sIdx) continue;
        if (v.options[j] !== current.options[j]) { sameRest = false; break; }
      }
      if (!sameRest) continue;
      var opt = document.createElement('option');
      opt.value = v.id;
      opt.textContent = v.options[sIdx] + (v.available ? '' : ' – ' + L.soldout);
      if (!v.available) opt.disabled = true;
      if (v.id === current.id) opt.selected = true;
      sel.appendChild(opt);
      added++;
    }
    if (added < 2) return null;

    sel.addEventListener('change', function () {
      var newId = sel.value;
      if (!newId || parseInt(newId, 10) === current.id) return;
      sel.disabled = true;
      swapSize(line.__line, newId, line.quantity);
    });
    return sel;
  }

  /* ---------- Merken-Button je Artikel ---------- */
  function buildSaveButton(line) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hm-save';
    btn.setAttribute('data-hm-save', '');
    var already = readSaved().some(function (x) { return String(x.id) === String(line.variant_id); });
    btn.innerHTML = (already ? HEART_FILLED : HEART_OUTLINE) +
      '<span>' + (already ? L.saved : L.save) + '</span>';
    if (already) btn.classList.add('is-saved');

    btn.addEventListener('click', function () {
      if (btn.classList.contains('is-busy')) return;
      btn.classList.add('is-busy');

      var list = readSaved();
      if (!list.some(function (x) { return String(x.id) === String(line.variant_id); })) {
        list.push({
          id: line.variant_id,
          title: line.product_title || line.title || '',
          variant: (line.variant_title && line.variant_title !== 'Default Title') ? line.variant_title : '',
          url: line.url || '',
          img: line.image ? (line.image.indexOf('http') === 0 ? line.image : 'https:' + line.image) : '',
          price: line.final_price
        });
        writeSaved(list);
      }

      /* ---- SOFORTIGE Rueckmeldung, noch vor dem Netzwerk ---- */
      btn.classList.add('is-saved');
      var sp = btn.querySelector('span'); if (sp) sp.textContent = L.saved;
      var sv = btn.querySelector('svg'); if (sv) sv.outerHTML = HEART_FILLED;
      ensureHeaderMerk();
      updateMerkBadge(true);
      toast(L.toastSaved);

      /* ---- danach aus dem Korb in den Merkzettel verschieben ---- */
      changeLine(line.__line, 0)
        .then(function (res) { applySections(res && res.sections); })
        .catch(function () { btn.classList.remove('is-busy'); });
    });
    return btn;
  }

  /* ---------- Merkzettel-Liste anzeigen ---------- */
  function renderSaved() {
    var inner = document.querySelector('#CartDrawer .drawer__inner') || document.querySelector('#CartDrawer');
    if (!inner) return;
    var footer = inner.querySelector('.drawer__footer');
    var list = readSaved();

    var wrap = inner.querySelector('[data-hm-saved]');
    if (!list.length) { if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap); return; }

    if (!wrap) {
      wrap = document.createElement('details');
      wrap.className = 'hm-foldout hm-saved';
      wrap.setAttribute('data-hm-saved', '');
      wrap.open = true;
      if (footer) inner.insertBefore(wrap, footer); else inner.appendChild(wrap);
    }
    var html = '<summary class="hm-foldout__sum"><span>' + L.saved + ' (' + list.length + ')</span></summary>' +
      '<div class="hm-foldout__body"><div class="hm-saved__track">';
    list.forEach(function (it, idx) {
      html += '<div class="hm-saved__card">' +
        (it.img ? '<img class="hm-saved__img" src="' + it.img + '" alt="" loading="lazy">' : '<div class="hm-saved__img"></div>') +
        '<div class="hm-saved__name">' + escapeHtml(it.title) + '</div>' +
        (it.variant ? '<div class="hm-saved__var">' + escapeHtml(it.variant) + '</div>' : '') +
        '<div class="hm-saved__price">' + (typeof it.price === 'number' ? money(it.price) : '') + '</div>' +
        '<button type="button" class="hm-saved__add" data-hm-saved-add="' + it.id + '">' + L.addToCart + '</button>' +
        '<button type="button" class="hm-saved__rm" data-hm-saved-rm="' + idx + '" aria-label="' + L.remove + '">&times;</button>' +
        '</div>';
    });
    html += '</div></div>';
    wrap.innerHTML = html;
  }

  /* ---------- Klicks in der Merkliste ---------- */
  document.addEventListener('click', function (e) {
    var add = e.target.closest ? e.target.closest('[data-hm-saved-add]') : null;
    if (add) {
      e.preventDefault();
      var id = add.getAttribute('data-hm-saved-add');
      add.classList.add('is-loading');
      var list = readSaved().filter(function (x) { return String(x.id) !== String(id); });
      writeSaved(list);
      updateMerkBadge(false);
      addVariant(id, 1).then(function (res) { applySections(res && res.sections); }).catch(function () {});
      return;
    }
    var rm = e.target.closest ? e.target.closest('[data-hm-saved-rm]') : null;
    if (rm) {
      e.preventDefault();
      var i = parseInt(rm.getAttribute('data-hm-saved-rm'), 10);
      var l2 = readSaved();
      l2.splice(i, 1);
      writeSaved(l2);
      renderSaved();
      updateMerkBadge(false);
    }
  });

  /* ---------- Bedienelemente einsetzen ---------- */
  function enhance() {
    var cont = document.querySelector('#CartDrawer');
    if (!cont) return;
    if (observing) observing.disconnect();

    ensureHeaderMerk();
    renderSaved();
    updateMerkBadge(false);

    var ctas = document.querySelector('#CartDrawer .cart__ctas');
    if (ctas && !ctas.querySelector('.hm-shopmore')) {
      var sm = document.createElement('button');
      sm.type = 'button';
      sm.className = 'hm-shopmore';
      sm.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg><span>' + L.shopmore + '</span>';
      sm.addEventListener('click', function () {
        var cd = document.querySelector('cart-drawer');
        if (cd && typeof cd.close === 'function') cd.close();
      });
      ctas.insertBefore(sm, ctas.firstChild);
    }

    getJSON(ROOT + 'cart.js').then(function (cart) {
      var rows = document.querySelectorAll('#CartDrawer .cart-item');
      (cart.items || []).forEach(function (line, i) {
        var row = rows[i];
        if (!row) return;
        line.__line = i + 1;

        var qcell = row.querySelector('.cart-item__quantity');
        if (qcell && !qcell.querySelector('.hm-save')) {
          var removeBtn = qcell.querySelector('cart-remove-button');
          var saveBtn = buildSaveButton(line);
          if (removeBtn) qcell.insertBefore(saveBtn, removeBtn); else qcell.appendChild(saveBtn);
        }

        var details = row.querySelector('.cart-item__details');
        if (details && !details.querySelector('.hm-size-select') && line.product_has_only_default_variant === false) {
          getProduct(line.handle).then(function (product) {
            if (!product) return;
            if (details.querySelector('.hm-size-select')) return;
            var sel = buildSizeSelect(line, product);
            if (!sel) return;
            var dl = details.querySelector('dl');
            var box = document.createElement('div');
            box.className = 'hm-size-row';
            box.innerHTML = '<span class="hm-size-label">' + L.size + ':</span>';
            box.appendChild(sel);
            if (dl && dl.nextSibling) details.insertBefore(box, dl.nextSibling);
            else details.appendChild(box);
          });
        }
      });
    }).catch(function () {}).finally(function () {
      if (observing && cont) observing.observe(cont, { childList: true, subtree: true });
    });
  }

  /* ---------- Start + Beobachtung ---------- */
  function boot() {
    var cont = document.querySelector('#CartDrawer');
    if (cont && window.MutationObserver) {
      var pending = false;
      observing = new MutationObserver(function () {
        if (pending) return;
        pending = true;
        setTimeout(function () { pending = false; enhance(); }, 120);
      });
    }
    enhance();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
